import React, {useEffect} from 'react';
import Nav from '../../Page Components/Nav';
import Footer from "../../Page Components/Footer";
import Card from "../../Co Components/SquareCards";
import Square from "../../Co Components/SquareCards";
import Title from "../../Co Components/Titles";
import homehero from '../../assets/Images/homehero.png';
import Rectangle from "../../Co Components/RectangleCards";
import LineButton from "../../Co Components/LineButton";
import hackerRed from '../../assets/Images/hacker.png';
import BlogCard from "../../Co Components/BlogCards";
import HomeCard from "../../Co Components/HomeCards";
import PrimaryButton from "../../Co Components/PrimaryButton";
import SecondaryButton from "../../Co Components/SecondaryButton";
const Vulnerability = () => {
useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <section className={' d-flex flex-row mt-0  align-items-center w-90 '}>
                <article>
                    <div className={'mx-5 w-75'}>
                        <h1 className={'bebas display-1 text-black bolde  line-normal'}>WhiteGuard
                            <span className={'bebas red'}><br /> Vulnerability Assessment</span><br />
                            Services</h1>
                    </div>

                    <div className={'w-75 mx-5'}>
                        <p className={'bolder h6'} >
                            Our Red Team Perform detailed Vulnerability
Assessments on all technical layers of your organization, from operating
systems, web applications to network devices, and classifies all
discovered vulnerabilities according to risk level and severity.
The results of Vulnerability Assessments performed by our experts will help
your organization develop an asset-aware security road map according
to which IT assets require immediate action.
                        </p>
                    </div>
                </article>
                <figure className=' headerImage align-self-center d-flex flex-column w-25'>
                    <HomeCard className={'danger'} />
                    <img src={hackerRed} className={'hackerImage z-1'} />
                </figure>

            </section>

            <Title className={'mt-6'} header={"the"} body={"Benefits"} />
            <div className={'d-flex mb-5 flex-row justify-content-center align-items-center flex-wrap'}>
                <Square className={'mx-4 cardRed mt-5'} Title={"Protect "} text={'Protect every endpoint—workstations, laptops, servers, virtual machines, web servers, and databases.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Gain unified "} text={'Gain unified, continuous visibility of your distributed IT irrespective of endpoints’ whereabouts.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Automatically detect vulnerabilities"} text={'Automatically detect vulnerabilities, misconfigurations, risky software, and much more.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Look beyond CVSS scores"} text={'Look beyond CVSS scores. Prioritize vulnerabilities based on age, exploitability, and impact.'}/>

                <Square className={'mx-4 cardRed mt-5'} Title={"spot"} text={'Swiftly spot zero-day vulnerabilities and apply mitigation work-arounds.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"bird’s-eye view"} text={'Gain a bird’s-eye view of your security posture.'} />
            </div>
            <Title className={'mt-6'} header={"the"} body={"Process"} />
            <div className={'d-flex mb-12 flex-column align-items-center justify-content-start process-container'} style={{ transition: 'all 0.3s ease' }}>
                <Rectangle className={'mt-4 cardRed'} Title={'Asset discovery'} text={'One of the most common cyber security challenges facing organizations is a lack of visibility into their digital infrastructure and its connected devices.'} />
                <Rectangle className={'mt-4 cardRed'} Title={'Prioritization'} text={'you would be running a vulnerability assessment regularly on all of your systems. However, vendors often charge per-asset, so prioritization can help where budgets can’t cover every asset the company owns.'} />
                <Rectangle className={'mt-4 cardRed'} Title={'Vulnerability scanning'} text={'Vulnerability scanners are designed to identify known security weaknesses and provide guidance on how to fix them.'} />
                <Rectangle className={'mt-4 cardRed'} Title={'Phishing Exercise'} text={'Email and phone-based social engineering. With a little \n' +
                    'bit of research on individuals or organizations, phishing emails become a lot more convincing. This low hanging fruit is frequently the first in a\n' +
                    ' chain of composite attacks that lead to the goal.'} />
                <Rectangle className={'mt-4 cardRed'} Title={'Result analysis & remediation'} text={'After the vulnerability scan is complete, the scanner provides an assessment report. When reading and developing remediation plans based on this report, you should consider Severity, Vulnerability Exposure.'} />
            </div>


            <Footer />
        </>
    );

}

export default Vulnerability;